import { QuizBuilderFinalStep } from '../../../common/QuizBuilder/QuizBuilderFinalStep';
import './styles.css';

export default QuizBuilderFinalStep;
